<div class="bg-white rounded-md p-2 flex gap-2 items-center">
    <div class="rounded-[4px] border border-divider-divider flex">
        <div class="border-r border-divider-divider flex justify-center items-center p-1">
            <img src="assets/icons/natural-stone.svg" alt="Natural stone" />
        </div>
        <div class="min-w-[18px] flex justify-center items-center p-1">
            <span class="min-w-[18px] min-h-[18px] typography-body-s-medium text-center">
                {{getTotalInCart()}}
            </span>
        </div>
    </div>
    <span class="typography-title-s">
        {{'natural_stone.added_slabs' | translate}}
    </span>
    <div>
        <app-link class="text-primary typography-body-m-regular" (onClick)="openMinicart()">
            <div class="flex items-center">
                <span>
                    {{'global.view' | translate}}
                </span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.99984 17.3L15.2998 12L9.99984 6.69995L9.29984 7.39995L13.8998 12L9.29984 16.6L9.99984 17.3Z" fill="currentColor"/>
                </svg>
            </div>
        </app-link>
    </div>
</div>

<div *ngIf="isMinicartOpen()" class="absolute z-50 right-0 top-0 left-0 h-[calc(100vh-81px)] bg-background-overlay-01" (click)="closeMinicart()">
    <div class="relative h-full">
        <div class="absolute top-0 right-0 bottom-0 p-4 bg-white max-w-[300px] !box-content" (click)="$event.stopPropagation()">
            <div class="h-full flex flex-col gap-8">
                <div class="flex flex-col gap-4">
                    <div class="flex justify-end h-6">
                        <img class="cursor-pointer" src="assets/icons/close-black.svg" alt="Close" (click)="closeMinicart()" />
                    </div>
                    <div>
                        <div class="flex gap-6 flex-wrap justify-between">
                            <span class="typography-title-s">
                                {{'natural_stone.added_slabs' | translate}}
                            </span>
                            <span class="typography-body-s-light">
                                {{(getTotalInCart() === 0 || getTotalInCart() > 1 ? 'natural_stone.added_slabs_plural' : 'natural_stone.added_slabs_singular') | translate:{varSlabs: getTotalInCart()} }}
                            </span>
                        </div>
                        <div class="mt-6 border-b border-divider-divider"></div>
                    </div>
                </div>
                <div class="flex-1 overflow-y-auto flex flex-col gap-4">
                    <ng-container *ngFor="let line of cart(); let last = last" >
                        <app-natural-stone-cart-line [line]="line" [minicart]="true" />
                        <div *ngIf="!last" class="border-b border-divider-divider"></div>
                    </ng-container>
                </div>
                <div>
                    <app-button
                        [disabled]="cart().length === 0"
                        [primary]="true"
                        [size]="'large'"
                        [isFullWidth]="true"
                        (onClick)="goToFinalizePreorder()"

                    >{{'common.buttons.confirm' | translate}}</app-button>
                </div>
            </div>
        </div>
    </div>
</div>